/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { createRef, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  useExportTicketsDetailList,
  useGetTicketsDetailList
} from "utils/apis/dashboard.api";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { process } from "@progress/kendo-data-query";
import { PATHS } from "routes/paths";
import { Button, Card, CardContent } from "@repo/ui";
import Loader from "ui/page-loader";
import { BreadCrumb } from "ui/bread-crumbs";
import { fixKendoGridContent, getTicketDetailsPage } from "pages/tickets/utils";
import GridDataCopyCell from "components/copy";
import { FaFileExcel } from "react-icons/fa";

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc"
    }
  ]
};

const pageSize = 100;

export default function DetailPage() {
  const [searchParams] = useSearchParams();
  const status = searchParams.get("status") || "opentotal";
  const assignmentGroup = searchParams.get("assignmentGroup") || "";
  const activityType = searchParams.get("activityType") || "";
  const customerId = searchParams.get("accountId") || "";
  const customerName = searchParams.get("customerName") || "";
  const region = searchParams.get("region") || "";
  const period = searchParams.get("period") || "all";
  const heading = searchParams.get("title") || "Tickets";
  const vaultAccessRequired = searchParams.get("vaultAccessRequired") === "Yes";
  const carriedOverCalls = searchParams.get("carriedOverCalls") === "Yes";
  const loggedToday = searchParams.get("loggedToday") === "Yes";
  const [dataState, setDataState] = useState<any>(initialDataState);
  const [currentPage, setCurrentPage] = useState(1);
  let _exporter: any = null;
  const { data: allTickets, isPending: gettingTickets } =
    useGetTicketsDetailList({
      period,
      pageNumber: currentPage,
      pageRowCount: pageSize,
      status,
      assignmentGroup,
      activityType,
      region,
      customerId,
      vaultAccessRequired,
      carriedOverCalls,
      loggedToday
    });
  const {
    mutate: getExportTickets,
    data: exportedTicketsRes,
    isPending: exportingTickets,
    reset: resetExportedTickets
  } = useExportTicketsDetailList();

  useEffect(() => {
    if (exportedTicketsRes?.data) {
      _exporter.save();
      resetExportedTickets();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportedTicketsRes]);

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };
  const onPageChange = (e: any) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
  };
  const excelExport = () => {
    if (_exporter) {
      getExportTickets({
        period,
        status,
        assignmentGroup,
        activityType,
        region,
        customerId,
        vaultAccessRequired,
        carriedOverCalls,
        loggedToday
      });
    }
  };

  return (
    <div className="box-border">
      {gettingTickets || exportingTickets ? <Loader /> : <></>}
      <BreadCrumb
        className="mx-4"
        items={[
          { text: "Dashboard", to: "/" },
          {
            text: heading
          }
        ]}
      />

      <Card className="mx-4 mt-5">
        <CardContent>
          <div className="flex items-end justify-end w-full">
            <Button
              className="mt-4"
              variant="secondary"
              onClick={() => {
                excelExport();
              }}
            >
              <FaFileExcel style={{ marginRight: "8px" }} />
              Export
            </Button>
          </div>

          <Grid
            data={process(allTickets?.data?.data || [], dataState)}
            {...dataState}
            onDataStateChange={onDataStateChange}
            onPageChange={onPageChange}
            filterable
            sortable
            pageable
            navigatable
            pageSize={pageSize}
            total={allTickets?.data?.totalRecords}
            skip={(currentPage - 1) * pageSize}
            className="mt-3"
            ref={(e) => {
              fixKendoGridContent(e);
            }}
          >
            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Resolve At"
              field="resolvedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
              filterable
            />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn
              title="Ticket Number"
              width="170px"
              field="caseNo"
              cell={(items) => {
                const dataItem = items.dataItem;
                return (
                  <GridDataCopyCell
                    dataItem={items.dataItem}
                    field={items.field}
                    customCell={
                      <td>
                        <Link to={getTicketDetailsPage(dataItem)}>
                          {dataItem.status === "Draft"
                            ? "View Draft"
                            : dataItem.caseNo}
                        </Link>
                      </td>
                    }
                  />
                );
              }}
            />

            <GridColumn
              title="Bank Reference No"
              field="customerTicketNo"
              width="200px"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />

            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn
              title="Description"
              field="remarks"
              width="400px"
              cell={GridDataCopyCell}
            />

            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
              cell={GridDataCopyCell}
            />
          </Grid>

          <ExcelExport
            data={exportedTicketsRes?.data?.data || []}
            fileName={`${heading}_Dashboard.xlsx`}
            ref={(e) => {
              if (e && !_exporter) {
                _exporter = e;
              }
            }}
          >
            <GridColumn
              title="Open At"
              field="createDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="Resolve At"
              field="resolvedDateTime"
              width="120px"
              className="text-center"
              headerClassName="text-center"
            />
            <GridColumn
              title="State"
              field="status"
              width="150px"
              className="text-center"
              headerClassName="text-center"
              filterable
            />
            <GridColumn title="Account" field="customer" width="170px" />
            <GridColumn title="Asset Id" field="locationId" width="150px" />
            <GridColumn title="Ticket Number" width="170px" field="caseNo" />

            <GridColumn
              title="Bank Reference No"
              field="customerTicketNo"
              width="200px"
            />
            <GridColumn
              title="Activity Type"
              field="activityType"
              width="170px"
            />
            <GridColumn title="Category" field="category" width="150px" />
            <GridColumn
              title="Sub Category"
              field="subCategory"
              width="150px"
            />
            <GridColumn title="Location" field="locationName" width="170px" />
            <GridColumn title="Region" field="region" width="150px" />
            <GridColumn
              title="Assignment Group"
              field="assignmentGroup"
              width="170px"
            />

            <GridColumn title="Reported By" field="reportedBy" width="170px" />
            <GridColumn title="Description" field="remarks" width="400px" />
            <GridColumn
              title="Resolution Notes"
              field="resolutionNotes"
              width="170px"
            />
          </ExcelExport>
        </CardContent>
      </Card>
    </div>
  );
}
